import { api } from '@api'
import type { Profile } from '@hvf/contracts'

export const updateProfile = async (profile: Partial<Profile>) => {
  if (!profile.id) {
    return
  }

  const { data, error } = await api()
    .from('profile')
    .update({
      username: profile.username,
    })
    .eq('id', profile.id)

  if (error) {
    console.error(error)
    throw new Error(error.message)
  }

  return data
}

export const updateProfilePicture = async ({
  file,
  id,
}: { file: File; id: string }) => {
  // Because of client-side processing, we can safely enforce .webp everywhere.
  const filePath = `${id}.webp`

  const { error: uploadError } = await api()
    .storage.from('profile-images')
    .upload(filePath, file, {
      upsert: true,
      contentType: 'image/webp',
      cacheControl: '3600',
    })

  if (uploadError) {
    console.error('Upload error:', uploadError)
    throw new Error(uploadError.message)
  }

  return filePath
}
